"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports.default = {
  path: '/area',
  component: _layout.default,
  redirect: '/area/index',
  name: 'Area',
  meta: {
    title: '店铺分组管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/area/index'));
      });
    },
    name: 'AreaIndex',
    meta: {
      title: '店铺分组列表'
    }
  }, {
    path: 'create/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/area/create'));
      });
    },
    name: 'AreaCreate',
    meta: {
      title: '店铺分组维护',
      activeMenu: '/area/index',
      noCache: true
    },
    hidden: true
  }, {
    path: 'areamenu/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/area/areamenu/index'));
      });
    },
    name: 'AreaMenu',
    meta: {
      title: '商户主体菜单管理'
    }
  }, {
    path: 'areamenu/indexf',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/area/areamenu/indexf'));
      });
    },
    name: 'AreaMenuF',
    meta: {
      title: '商户主体菜单管理'
    }
  }, {
    path: 'areamenu/platformBusinessRole',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/area/areamenu/platformBusinessRole'));
      });
    },
    name: 'PlatformBusinessRole',
    meta: {
      title: '商户主体超管管理'
    }
  }]
};